const validations = {
  files: [({attempted, files}) => {
    return (!attempted || files.length > 0) ? '' : 'homework-student-resources-required'
  }]
}

export default validations
